<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { Director } from '~~/server/api/corporation/profile'
import { SrcSet } from '~/composables/useSrcSet'

export interface PagesAboutProfileQuoteProps {
    data: Director
}

const props = defineProps<PagesAboutProfileQuoteProps>()
const { $formatTableHtml } = useNuxtApp()

const imageSrc = computed((): SrcSet | undefined =>
    useSrcSet(props.data.image.path)
)
</script>
<template>
  <LazyBox
    color="green-light"
    classes="mb-12 mb-md-20 mx-0 rounded row align-items-end g-md-0"
    padding="p-0 pt-10 ps-md-15 pe-0 pb-0"
  >
    <div class="col-12 col-md-7 mb-4 mb-md-0 pb-md-15">
      <svg
        width="63"
        height="61"
        class="text-green-2 mb-8"
        aria-hidden="true"
      >
        <use xlink:href="#icon-quotes" />
      </svg>

      <Typo class="mb-10">
        <div
          class="fs-biggest fs-md-huge"
          v-html="$formatTableHtml(props.data.description)"
        />
      </Typo>

      <Box
        decor-position="top-left"
        :padding="''"
        size="small"
        color="green"
        class="rounded px-3 px-md-5 py-3 d-inline-block"
      >
        <p class="mb-0 fs-smaller gamma">
          {{ props.data.name }}
        </p>
        <cite class="fst-normal fs-small">
          {{ props.data.position }}
        </cite>
      </Box>
    </div>

    <div class="col-12 col-md-5 pe-0">
      <img
        v-if="props.data.image.path"
        :src="imageSrc?.src"
        :srcset="imageSrc?.srcSet"
        width="456"
        height="714"
        loading="lazy"
        decoding="async"
        class="d-block w-100 h-100 object-fit-contain"
        :alt="props.data.name"
      >
    </div>
  </LazyBox>
</template>
